export default __webpack_public_path__ + "media/music/79cecb2b63e19c19918f76a31e1e91d7.mp3";